import React, { useEffect, useState } from 'react';
import TableList from '../../layout/TableList';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listAudienceTypesAction, editAudienceTypesAction, deleteAudienceTypesAction } from '../../../actions/audienceTypesActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import { Spinner } from 'react-bootstrap';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { PARAMETROS_ELIMINAR, PARAMETROS_MODIFICAR } from '../../../data/objects';
import QuickFilter from '../../layout/QuickFilter';
//Función Principal
const AudienceTypeList = props => {
    const params = {
        sort: 'descripcion:asc'
    }
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const audienceTypesLoading = useSelector( state => state.audienceTypes.loading );
    const audienceTypes = useSelector( state => state.audienceTypes.audienceTypes );
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [ data, setData ] = useState(null);
    //Manejo de la edición
    const handleEdit = item => {

        //Llamo al dispatch de edición
        dispatch( editAudienceTypesAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteAudienceTypesAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Descripción',
            width: null,
            style: null,
            field: 'descripcion'
        },
        {
            name: 'Categoría',
            width: null,
            style: 'text-center',
            field: 'categoria',
            subfield: 'descripcion'
        },
        {
            name: 'Prioridad',
            width: null,
            style: 'text-center',
            field: 'prioridad',
            subfield: 'descripcion'
        },
        {
            name: 'Pl. mín.',
            width: null,
            style: 'text-center',
            field: 'plazoMinimo'
        },
        {
            name: 'Pl. máx.',
            width: null,
            style: 'text-center',
            field: 'plazoMaximo'
        },
        {
            name: 'Tiempo',
            width: null,
            style: 'text-center',
            field: 'tiempo'
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, PARAMETROS_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Verifico si hay datos
        if(audienceTypes){
            //Seteo los datos
            setData(audienceTypes);
        }else{
            //Si no hay datos, debo cargarlo
            dispatch( listAudienceTypesAction(params) );
        }
        
    }, [audienceTypes]);
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            initialData={audienceTypes}
                            headers={headers}
                            setData={setData}
                        />
                        {
                            audienceTypesLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            data ? (
                                <TableList
                                    prefix="at"
                                    headers={headers}
                                    items={data}
                                    state={{
                                        field: 'activo',
                                        disabledClass: 'table-danger',
                                        disabledValue: 0,
                                        hideActions: true
                                    }}
                                />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AudienceTypeList;